import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePermissions } from "../context/PermissionsContext";
import Dashboard from "./Dashboard";
import DashboardHR from "./dashboards/DashboardHR";
import DashboardSecretary from "./dashboards/DashboardSecretary";
import DashboardIT from "./dashboards/DashboardIT";

/**
 * AP-021 · Role-aware dashboard router.
 * AP-131 · RBAC-first — usa permissões, sem role hardcode.
 *
 * Precedence:
 *   1. Dynamic role code (RBAC) → specialized dashboard.
 *   2. Legacy hardcoded role → default financial dashboard.
 *   3. Se o usuário só tem permissões `tech_*` (delegação JMS TECH pura),
 *      redireciona para /tech-admin.
 */
export default function DashboardRouter() {
  const { isLoading, roleCode, role, permissions, can } = usePermissions();

  if (isLoading) {
    return (
      <div className="min-h-[40vh] grid place-items-center text-muted-foreground" data-testid="dashboard-loading">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  // JMS TECH · Tech Admin acessa somente o painel do LMS
  if (roleCode === "tech_admin") return <Navigate to="/tech-admin" replace />;
  // AP-131 · Se o usuário só tem visibilidade em módulos `tech_*` e não
  // possui view no dashboard principal, direciona para o painel do LMS.
  if (!can("dashboard", "view") && can("tech_dashboard", "view")) {
    return <Navigate to="/tech-admin" replace />;
  }
  if (roleCode === "rh") return <DashboardHR />;
  if (roleCode === "secretaria" || roleCode === "atendimento") return <DashboardSecretary />;
  if (roleCode === "ti") return <DashboardIT />;
  // Legacy fallback for accounts still without a dynamic role.
  if (role === "employee") return <DashboardHR />;
  return <Dashboard />;
}
